import MessageUtil from '../util/MessageUtil';
import { query } from '@trlogic/client-js';
import { Dashboard } from '../domain/dashboard/DashboardDomains';
import DashboardClient from '../client/dashboard/DashboardClient';
import { ChartType } from '@trlogic/ui-pack';
import ChartUtil from '../util/ChartUtil';
import Query = query.Query;
import { CustomFilter } from '../domain/ui/FilterDomains';

class DashboardService {
  private readonly dashboardClient: DashboardClient;

  constructor(dashboardClient: DashboardClient) {
    this.dashboardClient = dashboardClient;
  }

  public async save(dashboard: Dashboard): Promise<string> {
    try {
      const response: string = await this.dashboardClient.save(dashboard);
      MessageUtil.success({
        summary: 'Dashboard saved successfully',
      });
      return response;
    } catch (e) {
      MessageUtil.error({
        summary: 'Error while saving dashboard',
      });
      return Promise.reject();
    }
  }

  public async remove(dashboard: Dashboard) {
    try {
      const response = await this.dashboardClient.remove(dashboard.name as string);
      if (response.status == 200) {
        MessageUtil.success({
          summary: 'Dashboard removed successfully',
        });
      }
    } catch (e) {
      console.log(e);
      MessageUtil.error({
        summary: 'Error while removing dashboard',
      });
    }
  }

  public async getDashboard(id: string, filter?: any) {
    const response = await this.dashboardClient.getDashboard(id, filter); // TODO USE CHAR UTIL SET COLOR PALETTE FUNCTION
    response?.charts?.map((chart: any) => {
      if (chart.isStaticChart) {
        return chart;
      }
      chart.result = ChartUtil.setColorPalette(chart.attributes, chart.result, chart.type as ChartType);
      return chart;
    });
    return response;
  }

  public async count(query: Query): Promise<number> {
    return await this.dashboardClient.count(query);
  }

  public async getRulePerformance(id: string, filter: CustomFilter) {
    return await this.dashboardClient.getRulePerformance(id, filter);
  }
}

export default DashboardService;
